module.exports = __webpack_public_path__ + "img/Children.a8f093ea.jpg";